import React, { useState } from "react";
import { css } from "react-emotion";
import styled from "react-emotion";
import { uploadWidget } from "helpers";
import { Button } from "appStyles";
import ShuffleIcon from "@material-ui/icons/Shuffle";
import Modal from "@material-ui/core/Modal";
import CloseIcon from "@material-ui/icons/Close";
import ImagesOrdering from "./ImagesOrdering";

const Container = styled("div")`
  position: relative;
  display: grid;
  grid-template-columns: ${(props) => `repeat(${props.columns}, 1fr)`};
  grid-template-rows: auto;
  grid-auto-rows: 1fr;
  grid-auto-flow: row;
  width: ${(props) => (props.columns === 1 ? "100%" : "80%")};
  * {
    position: relative;
  }
`;

const Image = css`
  width: 100%;
  height: auto;
  object-fit: cover;
  cursor: pointer;
`;

const imageText = css`
  border: 1px solid black;
  display: inline;
  font-family: inherit;
  font-size: 0.6em;
  padding: 5px;
  width: 100%;
  height: 3em;
  outline: none;
  cursor: text;

  &::placeholder {
    font-size: 0.5rem;
  }
`;

const imageTextContainer = css`
  width: 100%;
  bottom: 0;
  background: rgba(112, 112, 112, 0.5);
  display: flex;
  flex-direction: row;

  input:first-child {
    text-align: left;
  }

  input:nth-child(2) {
    text-align: right;
  }
`;

// TODO: dynamically set color
const Description = css`
  color: #707070;
  font-size: 9px;
  width: 100%;
  height: 5em;
  cursor: text;
  resize: none;
  padding: 5px;
`;

const ItemContainer = styled("div")`
  width: 70%;
  margin: auto;
  margin-bottom: 1em;
`;

// TODO: dynamically set background later
const Circle = styled("div")`
  border-radius: 50%;
  background: white;
  margin-top: 5px;
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
`;

const LowerItemContainer = styled("div")`
  display: flex;
  justify-content: row;
`;

const ImageContainer = styled("div")`
  /* margin: 5px; */
`;

const RemoveImage = styled("div")`
  width: 100%;
  height: 20px;
  top: 0;
  right: 0;
  text-align: right;
  cursor: pointer;
  position: absolute;
  right: -16px;
`;

const ImageItems = ({
  appId,
  images,
  columns,
  onClick,
  onChange,
  removeImage,
  croppingAspectRatio,
  updateImages,
  props,
}) => {
  const update = (idx, field) => (e) => onChange(idx, field, e.target.value);
  const updateImage = (idx, field) => (imageUrl) =>
    onChange(idx, field, imageUrl);
  // console.log("#### cropping aspect ratio:" + croppingAspectRatio);
  const [showReorderImagesModal, setShowReorderImagesModal] = useState(false);
  const toggleReorderImagesModal = () => {
    setShowReorderImagesModal(!showReorderImagesModal);
  };
  const renderReorderImagesModal = () => {
    if (!showReorderImagesModal) return null;
    return (
      <Modal
        open={showReorderImagesModal}
        disableAutoFocus={true}
        onClose={toggleReorderImagesModal}
        style={{
          margin: "auto",
          width: "35%",
          top: "10%",
          left: "0%",
          overflowY: "auto",
          padding: "1em",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            height: "560px",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <span
            style={{ cursor: "pointer" }}
            onClick={toggleReorderImagesModal}
          >
            <CloseIcon></CloseIcon>
          </span>
          <ImagesOrdering
            images={images}
            closeImageModal={toggleReorderImagesModal}
            updateImages={updateImages}
            {...props}
          />
        </div>
      </Modal>
    );
  };
  return (
    <div>
      <Container columns={columns} onClick={onClick}>
        {renderReorderImagesModal()}
        {images &&
          images.map((image, idx) => {
            const { url, sideTitle, title, description } = image;

            return (
              <ItemContainer
                key={idx}
                style={{ width: columns === 1 ? "25%" : "70%" }}
              >
                <RemoveImage onClick={() => removeImage(idx)}>X</RemoveImage>
                <ImageContainer>
                  <img
                    className={Image}
                    onClick={() =>
                      uploadWidget(updateImage(idx, "url"), appId, {
                        croppingAspectRatio,
                      })
                    }
                    src={
                      url
                        ? url
                        : "https://mobile360-assets.s3.us-east-2.amazonaws.com/upload.png"
                    }
                    alt={url}
                  />
                  <div className={imageTextContainer}>
                    <input
                      onChange={update(idx, "title")}
                      placeholder="Enter a Title"
                      value={title}
                      className={imageText}
                    />
                    <input
                      onChange={update(idx, "sideTitle")}
                      placeholder="Additional Info"
                      value={sideTitle}
                      className={imageText}
                    />
                  </div>
                </ImageContainer>
                <LowerItemContainer>
                  <textarea
                    onChange={update(idx, "description")}
                    placeholder="Enter a Description"
                    value={description}
                    className={Description}
                  />
                  {/* <Circle/> */}
                </LowerItemContainer>
              </ItemContainer>
            );
          })}
      </Container>
      {images.length > 1 && (
        <div
          style={{
            margin: "0.3em",
            marginBottom: "1rem",
          }}
        >
          <Button
            background="#89D2D3"
            onClick={toggleReorderImagesModal}
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              fontStyle: "normal",
              fontStretch: "normal",
              letterSpacing: "normal",
              margin: "0px",
              display: "inline-flex",
              alignItems: "center",
              textAlign: "center",
              lineHeight: "29px",
              borderRadius: "5.5px",
              backgroundColor: "#89d2d3",
              boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
              textTransform: "none",
            }}
          >
            <ShuffleIcon style={{ marginRight: "5px" }}></ShuffleIcon>
            Reorder Images
          </Button>
        </div>
      )}
    </div>
  );
};

export default ImageItems;
